import React from 'react';
import { NavLink } from 'react-router-dom';
import { DollarSign } from 'lucide-react';

/**
 * PricingTabs
 * 
 * Component for pricing tab navigation with clear styling and accessible markup
 */
const PricingTabs = () => {
  const tabs = [
    { id: 'registration', label: 'Registration Pricing' },
    { id: 'competition', label: 'Competition Pricing' },
  ];

  return (
    <div className="card bg-base-100 border border-base-300">
      <div className="card-body p-6">
        <div className="flex items-center gap-4 mb-6">
          <div className="p-3 rounded-lg bg-primary/10">
            <DollarSign className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h2 className="card-title text-lg font-semibold">Pricing Type</h2>
            <p className="text-base-content/60 text-sm">Select which type of pricing to configure</p>
          </div>
        </div>

        <div className="tabs tabs-boxed" role="tablist">
          {tabs.map(({ id, label }) => (
            <NavLink
              key={id}
              to={`/admin/settings/pricing/${id}`}
              end
              className={({ isActive }) =>
                `tab border border-base-300 hover:bg-base-200 transition-all duration-200 ${
                  isActive ? '!bg-primary !text-primary-content font-medium' : ''
                }`
              }
              role="tab"
              aria-selected={isActive => isActive}
            >
              {label}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingTabs;
